import { Box } from '@/ui';
import {
  projectSettingsPanelActionRowInnerSx,
  projectSettingsPanelActionRowSx,
} from './projectSettingsSurfaceSx';
import type { ReactElement, ReactNode } from 'react';

type SettingsPanelActionRowProps = {
  children: ReactNode;
};

export const SettingsPanelActionRow = ({ children }: SettingsPanelActionRowProps): ReactElement => (
  <Box sx={projectSettingsPanelActionRowSx}>
    <Box sx={projectSettingsPanelActionRowInnerSx}>{children}</Box>
  </Box>
);
